import {
    useEffect,
    useState
} from "react";
import { getTool, getTools } from "./services";

export function useToolsPage(query, order, cursor) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(function () {
        setLoading(true);
        getTools(query, order, cursor)
            .then(function (response) {
                setLoading(false);
                setData(response.data);
            })
            .catch(function (error) {
                setLoading(false);
                setError(error);
            });
    }, [query, order, cursor]);

    return [loading, data, error];
}

export function useTool(id) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(function () {
        setLoading(true);
        getTool(id)
            .then(function (response) {
                setLoading(false);
                setData(response.data);
            })
            .catch(function (error) {
                setLoading(false);
                setError(error);
            });
    }, [id]);

    return [loading, data, error];
}